import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Classes } from '@blueprintjs/core';
import { ace_hooks } from '@axo/shared/data-access/hooks';
import { MenuNode } from './menuNode';
import styles from './styles.module.css';

export function useRecentApplicationsNodes(marketCountry: string): MenuNode[] {
  const navigate = useNavigate();

  const apps = ace_hooks.useRecentlyOpenedApplications(marketCountry, 50);

  const nodes = useMemo<MenuNode[]>(() => {
    if (apps.length < 1) {
      return [
        {
          id: '4B41E723-E44E-4859-8875-3C1E3596C4E8',
          disabled: true,
          className: Classes.TEXT_MUTED,
          label: 'No applications',
        },
      ];
    }

    return apps.map((app) => ({
      id: 'recent-applications/' + app.LoanApplicationID,
      label: app.HumanReadableID ?? '',
      nodeData: {
        onClick: () => navigate(`/application/${app.LoanApplicationID}`),
      },
    }));
  }, [apps, navigate]);

  return useMemo(
    () => [
      {
        id: '337A8143-755F-4B3A-ACAB-8F1062416211',
        hasCaret: true,
        icon: 'history',
        label: 'Recent applications',
        className: styles.clickable,
        childNodes: nodes,
      },
    ],
    [nodes],
  );
}
